import type { CockpitRole } from '@/auth/AuthProvider';
import { ROLE_VALUES } from '@/auth/AuthProvider';

export const DEV_ROLE_STORAGE_KEY = 'cockpit.dev.selectedRole';

export function isDevAuthMode(): boolean {
  // Show/send the role switcher only in local/dev-auth builds. Deployed Entra
  // environments must use app-role assignments as the source of truth.
  return !import.meta.env.PROD || import.meta.env.VITE_ENTRA_AUTH_MODE === 'dev';
}

export function readDevRolePreference(): CockpitRole | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(DEV_ROLE_STORAGE_KEY);
    if (!value) return null;
    return ROLE_VALUES.includes(value as CockpitRole) ? (value as CockpitRole) : null;
  } catch {
    return null;
  }
}

export function writeDevRolePreference(role: CockpitRole | null): void {
  try {
    if (role === null) {
      window.localStorage.removeItem(DEV_ROLE_STORAGE_KEY);
    } else {
      window.localStorage.setItem(DEV_ROLE_STORAGE_KEY, role);
    }
  } catch {
    // localStorage may be disabled by browser privacy settings; in-memory state still works.
  }
}

export function buildDevRoleHeaders(role: CockpitRole | null): Record<string, string> {
  if (!isDevAuthMode() || role === null) return {};
  return { 'x-dev-roles': role };
}
